import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d807465"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RegistrationHeader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "Title" }, [
  /*#__PURE__*/_createTextVNode(" Create a "),
  /*#__PURE__*/_createElementVNode("span", { class: "TitleHighlight" }, " free account "),
  /*#__PURE__*/_createTextVNode(" to submit question ")
], -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SubText" }, " Receive your personalized answer directly in your inbox. ", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SubText DesktopOnly" }, " We’ll send your answer directly to your inbox. ", -1 /* HOISTED */))
const _hoisted_5 = {
  key: 0,
  class: "BenefitsList"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "lnr-checkmark-circle BenefitIcon",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "BenefitLabel" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<li class=\"Benefit TrustedBy\" data-v-1d807465><i class=\"lnr-checkmark-circle BenefitIcon\" aria-hidden=\"true\" data-v-1d807465></i><span class=\"BenefitLabel\" data-v-1d807465>Trusted by millions</span></li><li class=\"Benefit TrustedBy DesktopOnly\" data-v-1d807465><i class=\"lnr-checkmark-circle BenefitIcon\" aria-hidden=\"true\" data-v-1d807465></i><span class=\"BenefitLabel\" data-v-1d807465>Trusted by 4M+ users</span></li>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (!_ctx.isRegister)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit) => {
            return (_openBlock(), _createElementBlock("li", {
              key: benefit,
              class: "Benefit"
            }, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(benefit), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _hoisted_8
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}